import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { toast } from 'react-toastify'

import { Dialog, Text } from '@loadsmart/miranda-react'

import { RequestStatus } from 'core/domain/Request'

import { useUpdateShipmentTractorNumber } from '../hooks/useUpdateShipmentTractorNumber'

type UnassignTruckNumberDialogProps = {
  open: boolean
  shipmentUUID: string
  onClose: () => void
  onTruckUnassigned: () => void
}

export function UnassignTruckNumberDialog({
  open,
  shipmentUUID,
  onClose,
  onTruckUnassigned,
}: UnassignTruckNumberDialogProps) {
  const { updateTractor, requestStatus } = useUpdateShipmentTractorNumber()

  useEffect(() => {
    if (requestStatus === RequestStatus.Done) {
      toast.success('Truck unassigned successfully')
      onTruckUnassigned()
      onClose()
    }

    if (requestStatus === RequestStatus.Error) {
      toast.error('Failed to unassign the truck')
    }
  }, [onClose, onTruckUnassigned, requestStatus])

  async function handleSave() {
    updateTractor({
      shipmentUUID,
      tractorNumber: null,
    })
  }

  return createPortal(
    <Dialog open={open} data-testid="unassign-truck-dialog" onClose={onClose} variant="danger">
      <Dialog.Header>
        Unassign truck
        <Dialog.Close data-testid="unassign-truck-dialog-close" onClick={onClose} />
      </Dialog.Header>
      <Dialog.Body>
        <Text>
          This action will affect the current tracking being provided to the shipper. Are you sure
          you want to unassign the truck from this load?
        </Text>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={onClose}>Cancel</Dialog.ActionTertiary>
        <Dialog.ActionPrimary
          onClick={handleSave}
          loading={requestStatus === RequestStatus.Pending}
        >
          Unassign truck
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>,
    document.body,
    'unassign-truck-dialog-root'
  )
}
